import { isTextLikeFormElementType } from '@/common/utils/liveFormFieldOverrides'

/**
 * Swing `SwingVisualEntityReloadHelper.reload`: after fill, `doOnChangeAction`.
 * TEXT onChange is otherwise Enter/blur; MULTISELECT chip click already fires onChange,
 * but refillElement/reload (form onLoad) does not unless this hook runs.
 */
export function shouldInvokeOnChangeAfterTextRefill(
  elementType: string | undefined | null,
  onChangeScript: string | undefined | null,
): boolean {
  const normalized = String(elementType ?? '').trim().toUpperCase()
  if (!isTextLikeFormElementType(elementType) && normalized !== 'MULTISELECT') return false
  return Boolean(String(onChangeScript ?? '').trim())
}

export function invokeOnChangeAfterTextRefill(options: {
  elementType: string | undefined | null
  onChangeScript: string | undefined | null
  invokeEvent: (eventName: string) => unknown
  running: { current: boolean }
  elementName?: string
}): void {
  if (options.running.current) return
  if (!shouldInvokeOnChangeAfterTextRefill(options.elementType, options.onChangeScript)) return

  options.running.current = true
  try {
    void options.invokeEvent('onChange')
  } finally {
    options.running.current = false
  }
}
